import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const UTCToDayjs = (value?: string): Dayjs | "" =>
  value ? dayjs.utc(value.substring(0, 21)) : "";

export default UTCToDayjs;
